import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const EASE = [0.76, 0, 0.24, 1];
const TESTIMONIALS_URL = "https://instagram.com/feedbacks";
const QR_IMG =
  "https://customer-assets-jai6qajn.emergentagent.net/job_akanksha-creative/artifacts/zlqu4v1g_IMG_0277.webp";

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      className="relative border-t hairline py-24 md:py-40"
      data-testid="testimonials-section"
    >
      <div className="grid grid-cols-12 gap-6 md:gap-10 px-6 md:px-10 lg:px-14">
        <div className="col-span-12 md:col-span-3 label">07 — Testimonials</div>

        <div className="col-span-12 md:col-span-9">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1, ease: EASE }}
            className="font-serif text-5xl md:text-7xl leading-[1.05] text-ink max-w-4xl"
          >
            Words from the{" "}
            <span className="italic">people we build with.</span>
          </motion.h2>

          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 mt-14 md:mt-20 items-center">
            {/* QR panel */}
            <motion.a
              href={TESTIMONIALS_URL}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 1, ease: EASE, delay: 0.1 }}
              className="col-span-12 md:col-span-5 group block"
              data-testid="testimonials-qr-link"
            >
              <div className="relative bg-white p-6 md:p-8 shadow-[0_20px_60px_-30px_rgba(26,24,21,0.35)] transition-transform duration-700 group-hover:-translate-y-1">
                <img
                  src={QR_IMG}
                  alt="Scan QR code to read testimonials on Instagram"
                  loading="lazy"
                  className="w-full h-auto object-contain"
                  data-testid="testimonials-qr-image"
                />
              </div>
              <div className="mt-4 flex items-baseline justify-between gap-4">
                <span className="label">Scan to view</span>
                <span className="label group-hover:text-ink transition-colors">
                  @akankshagrowsbrands
                </span>
              </div>
            </motion.a>

            {/* Copy + CTA */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.9, ease: EASE, delay: 0.2 }}
              className="col-span-12 md:col-span-7"
            >
              <span className="label">Client Feedback</span>
              <p className="mt-5 font-serif italic text-2xl md:text-3xl leading-snug text-ink/90">
                “Working with Akanksha feels less like hiring an agency and
                more like adding a creative director to the team — sharp
                strategy, elevated aesthetics, and follow-through.”
              </p>
              <p className="mt-6 font-sans text-base md:text-lg text-ink/75 leading-relaxed max-w-lg">
                Scan the QR — or tap through — to see the full wall of client
                love, campaign shout-outs, and collaborator notes on our
                Instagram feed.
              </p>

              <a
                href={TESTIMONIALS_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="testimonials-cta"
                className="group mt-10 inline-flex items-center gap-4 border-t border-b hairline py-5 pr-6 pl-1 hover:pl-4 transition-[padding] duration-500"
              >
                <span className="font-serif italic text-2xl md:text-3xl">
                  Read all testimonials
                </span>
                <ArrowUpRight
                  className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-500"
                  strokeWidth={1}
                />
              </a>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
